'use client';

import dynamic from 'next/dynamic';

export const PlpFiltersModalWrapperDynamic = dynamic(
  () =>
    import('src/plp/components/PlpFilters/PlpFiltersModal/PlpFiltersModalWrapper').then(
      (mod) => mod.PlpFiltersModalWrapper,
    ),
  { ssr: false, loading: () => null },
);
